import { useState } from 'react';
import Header from './components/Header';
import Infos from './components/Infos';
import Form from './components/Form';
import About from './components/About';
import Footer from './components/Footer';
import TermsAndConditions from './components/TermsAndConditions';

import './App.scss';

function App() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <>
      <TermsAndConditions
        modalIsOpen={modalIsOpen}
        handleCloseModal={handleCloseModal}
      />

      <main>
        <Header>
          <Infos />
          <Form
            handleOpenModal={handleOpenModal}
          />
        </Header>

        <About />

        <Footer
          handleOpenModal={handleOpenModal}
        />
      </main>
    </>
  )
}

export default App
